import { Injectable } from '@angular/core'
import { Subscription } from 'rxjs'

interface TrackedSubscription {
  key: string
  subscription: Subscription
}

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService {
  private subscriptions: TrackedSubscription[] = []

  register(key: string, subscription: Subscription): void {
    this.closed(key)
    this.subscriptions.push({ key, subscription })
  }

  closed(key: string): void {
    const index = this.subscriptions.findIndex((s) => s.key === key)
    if (index >= 0) {
      this.subscriptions[index].subscription.unsubscribe()
      this.subscriptions.splice(index, 1)
    }
  }
}
